export * from '@buf/cosmos_cosmos-sdk.bufbuild_es/cosmos/bank/v1beta1/tx_pb.js';
//# sourceMappingURL=tx.js.map